import React, { useState } from 'react'

import { SortingState } from '@tanstack/react-table'
import { isEmpty } from 'lodash-es'
import styled from 'styled-components/native'

import { Prescription } from '@lyrahealth-inc/shared-app-logic/src/models/prescription/Prescription'

import useMedicationsListColumns from './useMedicationsListColumns'
import { BodyText } from '../../atoms/bodyText/BodyText'
import { MedicineIcon } from '../../atoms/icons/MedicineIcon'
import { BodyTextSize } from '../../styles/typeStyles'
import { DataTable } from '../dataTable/DataTable'

const EmptyStateContainer = styled.View(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '400px',
  padding: theme.spacing['24px'],
}))

const IconWrapper = styled.View(({ theme }) => ({
  marginBottom: theme.spacing['16px'],
}))

type Props = {
  medications?: Prescription[]
  isPrescriber: boolean
}

function MedicationsList({ medications = [], isPrescriber }: Props) {
  const [sortingState, setSortingState] = useState<SortingState>([
    {
      id: 'WrittenDate',
      desc: true,
    },
  ])
  const columns = useMedicationsListColumns()

  const handleSortingChange = (sorting: SortingState) => {
    setSortingState(sorting)
  }

  if (isEmpty(medications)) {
    const emptyStateText = isPrescriber
      ? "This client doesn't have any medications prescribed yet. Click on Add Medications to access Dosespot and prescribe medications."
      : "This client doesn't have any medications prescribed."
    return (
      <EmptyStateContainer>
        <IconWrapper>
          <MedicineIcon width='50' />
        </IconWrapper>
        <BodyText size={BodyTextSize.DEFAULT} text={emptyStateText} textAlign='center' />
      </EmptyStateContainer>
    )
  }

  return (
    <DataTable
      data={medications}
      columns={columns}
      pagination={{ pageSize: 10 }}
      rowHeight='auto'
      sortingState={sortingState}
      onSortingChange={handleSortingChange}
      cellAlignment='left'
      withRowCount
    />
  )
}

export default MedicationsList
